import React from 'react';

import { ClauseText } from './Components/ContractText';

const FinancialStatus = () => {
  return (
    <div>
      <h2 className="text-xl font-bold uppercase mt-8 mb-2 border-b pb-1">
        Change in Financial Status of Buyer
      </h2>
      <ol className="text-black mb-4 text-base list-decimal list-inside text-bold">
        <li>
          If a change in{' '}
          <span className="font-bold">Buyer’s financial status</span> affects{' '}
          <span className="font-bold">Buyer’s ability to purchase</span>,{' '}
          <span className="font-bold">Buyer</span> will promptly notify{' '}
          <span className="font-bold">Seller</span> and lender(s) to whom the
          Buyer submitted a mortgage application, if any, in writing. A change
          in financial status includes, but is not limited to:
          <ul className="list-disc ml-8 mt-2">
            <li>Loss or a change in employment</li>
            <li>Failure or loss of sale of Buyer’s home</li>
            <li>Buyer having incurred a new financial obligation</li>
            <li>Entry of a judgment against Buyer</li>
          </ul>
          Buyer understands that applying for and/or incurring an additional
          financial obligation may affect Buyer’s ability to purchase.
        </li>
      </ol>
    </div>
  );
};

export default FinancialStatus;
